import firebase from 'firebase'
// Initialize Firebase
let config = {
  apiKey: 'AIzaSyC1O5HLLtkvJTiLObocZmiWUehGm4U7_ho',
  authDomain: 'ping-pong-4b040.firebaseapp.com',
  databaseURL: 'https://ping-pong-4b040.firebaseio.com',
  projectId: 'ping-pong-4b040',
  storageBucket: 'ping-pong-4b040.appspot.com',
  messagingSenderId: '130360190299'
}
export const firebaseApp = firebase.initializeApp(config)
export const db = firebaseApp.database();



// WEBPACK FOOTER //
// ./src/utils/firebase.js